import React from 'react';
/*import '../../styles/requestConfirmed.css';*/
import '../../styles/uploadimage.css';
import '../../styles/accept-buy-request.css';

export default class paymentDetails extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry">
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    UPDATE BANK DETAILS
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>

                            <div className="col-sm-6 UploadPaintingCard no-margin padding-35 payment-block payment-mob">
                                <div className="col-md-12">

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="existing-bank-details-section">
                                                <div className="bg-grey p-25">
                                                    <div className="existing-bank-details-heading">Existing Bank Details</div>
                                                    <div style = {{display : "flex"}}>

                                                        <div className="existing-bank-details">
                                                            ACCOUNT NUMBER : 12345678
                                                        </div>
                                                        <div className="existing-bank-details">
                                                            SWIFT CODE : RBL12345
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="heading-text pb-25">
                                            <div className="onboarding-question" style={{ paddingLeft: "unset" }}>
                                                NEW BANK DETAILS
                                            </div>
                                        </div>
                                        <div className="profile-details-dropdown-container">
                                            <div className="profile-details-country-dropdown">
                                                <p className="form-section-name-user-profile">BANK AC NUMBER</p>
                                                <input className="form-element-small-input" />
                                            </div>
                                            <div className="profile-details-country-dropdown">
                                                <p className="form-section-name-user-profile">SWIFT CODE</p>
                                                <input className="input-text" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="padding-top-x20"></div>

                                    <p className="new-detials mt-15 ml-15 mb-15 ">New Details will take upto 48 hours to update.</p>

                                    <p className="ml-15">
                                        <input type="submit" name="submit" className="masterpieces-primary-buttons btn-primary mt-25 mb-25"
                                            value="UPDATE DETAILS" />
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </div >

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/requests_forms/payment-details.js